<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="asset-info-card">
          <div class="row">
            <div class="col-md-3 info-block text-center">
              <div class="info-label">Asset Name</div>
              <div class="info-value s-32 text-head">{{ data.name }}</div>
            </div>

            <div class="col-md-3 info-block text-center">
              <div class="info-label">Category</div>
              <div class="info-value text-head">{{ data.category }}</div>
            </div>

            <div class="col-md-3 info-block text-center">
              <div class="info-label">Location</div>
              <div class="info-value text-head">{{ data.location }}</div>
            </div>

            <div class="col-md-3 info-block text-center">
              <div class="info-label">Status</div>
              <div class="info-value text-head">
                {{ statusOptions[data.status] }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-8">
        <div class="asset-section">
          <h2 class="section-title">Asset Images</h2>
          <div class="row images-container" >
            <div class="col-md-4" v-if="data && data.image3Url">
              <div class="asset-image">
                <img
                  :src="data.image3Url"
                  alt="Barcode"
                  class="barcode-image img-fluid"
                />
                <!-- <img
                  src="../../../assets/bus2.png"
                  alt="Blue Coaster Bus"
                  class="img-fluid"
                /> -->
              </div>
            </div>
            <div class="col-md-4" v-if="data && data.image2Url">
              <div class="asset-image">
                <img
                  :src="data.image2Url"
                  alt="Barcode"
                  class="barcode-image img-fluid"
                />
                <!-- <img
                  src="../../../assets/bus1.png"
                  alt="White Coach Bus"
                  class="img-fluid"
                /> -->
              </div>
            </div>
            <div class="col-md-4" v-if="data && data.image3Url">
              <div class="asset-image">
                <img
                  :src="data.image3Url"
                  alt="Barcode"
                  class="barcode-image img-fluid"
                />
                <!-- <img
                  src="../../../assets/bus1.png"
                  alt="Asset Barcode"
                  class="img-fluid"
                /> -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4 pr-0">
        <div class="barcode-container">
          <img
            v-if="data && data.barCode"
            :src="data.barCode"
            alt="Barcode"
            class="barcode-image img-fluid"
          />
          <img
            v-else
            src="../../../assets/barcodeIcon.png"
            alt="Barcode"
            class="barcode-image img-fluid"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
});

const statusOptions = ref([
  "Available",
  "InUse",
  "UnderMaintenance",
  "InUse",
  "Retired",
]);
// Component is static for now based on design, but can be modified to accept props
</script>

<style scoped>
.asset-info-card {
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 30px;
  margin-bottom: 30px;
}

.info-block {
  position: relative;
}

/* Add borders between columns except for the last one */
@media (min-width: 768px) {
  .info-block:not(:last-child)::after {
    content: "";
    position: absolute;
    right: 0;
    top: 10%;
    height: 80%;
    width: 1px;
    background-color: #e0e0e0;
  }
}

.info-label {
  font-size: 20px;
  color: #646464;
  font-weight: 400;
}

.info-value {
  font-size: 20px;
  font-weight: 700;
  color: #111111;
}

.section-title {
  font-size: 20px;
  font-weight: 400;
  color: #646464;
  margin-bottom: 16px;
}

.asset-image {
  height: 160px;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 15px;
}

.asset-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.barcode-container {
  padding-top: 40px;
  display: flex;
  justify-content: flex-end;
}

.barcode-image {
  max-width: 100%;
  height: auto;
}

/* Make sure the layout works on smaller screens */
@media (max-width: 767px) {
  .info-block {
    margin-bottom: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid #e0e0e0;
  }

  .info-block:last-child {
    border-bottom: none;
  }

  .barcode-container {
    padding-top: 20px;
    justify-content: center;
  }
}
</style>
